// Hooks / Node modules / Styles
import { Tag } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function ExperienceCard({ experience }) {
  return (
    <div className="flex local-theme-bg-md local-theme-border-md shadow-lg rounded-lg p-6 border border-gray-200">
      {/* Left Section: Logo */}
      <div className="flex-shrink-0 pt-1">
        <img
          src={experience.logo}
          alt={experience.company}
          className="w-16 h-16 object-contain rounded-md"
        />
      </div>

      {/* Right Section: Experience Details */}
      <div className="ml-4 flex flex-col justify-start">
        <h2 className="local-theme-text-md text-xl font-semibold">{experience.title}</h2>
        <p className="local-theme-text-sm">{experience.company}</p>
        <p className="local-theme-text-xs text-sm">{experience.duration}</p>
        <p className="local-theme-text-sm mt-2">{experience.description}</p>
        <p className="text-gray-500 text-xs mt-1">{experience.location}</p>
        
        {/* Tech Stack Tags */}
        <div className="flex flex-wrap mt-3">
          {experience.tech.map((tech, index) => (
            <Tag key={index} text={tech} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ExperienceCard;